import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "OpinionService",
  controller: "WebContentComment",
};

const methods = [
  "GetOpinionCommentShow",
  "GetAvgScoreByDayTrend",
  "GetCountByDayTrend",
  "GetScoreTrend",
  "GetCountByWebSite",
  "GetCommentHotWebContent",
  "GetCommentHotKeyWords",
  "GetOpninionHotComment",
  "GetCommentScoreRange",
  "GetOpinionHotCommentCountRange",
  "GetOpninionBadComment"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function (data) {
      return this.post(path, data);
    };
  });
};

const OpinionCommentApi = ZJApi.defineNewApi("OpinionCommentApi", factory);

export default OpinionCommentApi;
